export default "__VITE_ASSET__CtiYW7Hs__"